import { TermLength, InvestmentIndex } from "./CalculatorInputs";

export interface IndexDateRangeConfig {
    startYear: number;
    endYear: number;
}

/**
 * This represents an investment period starting January of startYear and
 * ending December of endYear. So a one-year investment term will have the same
 * startYear and endYear, and a 6-year term will have a difference of 5 between
 * startYear and endYear.
 */
export interface AvailableDateRangeConfig {
    startYear: number;
    endYear: number;
}

export interface IndexDateRangeConfig extends AvailableDateRangeConfig {
    index: string;

}


class YearRange implements AvailableDateRangeConfig {
    readonly startYear: number;
    readonly endYear: number;

    constructor(startYear: number, endYear: number) {
        this.startYear = startYear;
        this.endYear = endYear;
    }
}

export class AvailableDateRanges {
    private readonly rangesByIndexCode: Map<string, AvailableDateRangeConfig>;

    constructor(indexConfigs: Array<IndexDateRangeConfig>) {
        this.rangesByIndexCode = new Map<string, AvailableDateRangeConfig>();
        for (const indexConfig of indexConfigs) {
            const indexCode = indexConfig.index;
            const range: AvailableDateRangeConfig = { startYear: indexConfig.startYear, endYear: indexConfig.endYear };
            this.rangesByIndexCode.set(indexCode, range);
        }
    }
    
    getRangeForInvestmentIndex(invIndex: InvestmentIndex): AvailableDateRangeConfig {
        if (this.rangesByIndexCode.has(invIndex.code)) {
            const range = this.rangesByIndexCode.get(invIndex.code);
            if (range) {
                return new YearRange(range.startYear, range.endYear);
            } else {
                throw new Error(`No date range config for investment index: ${invIndex.code}`);
            }
        } else {
            throw new Error(`Unknown investment index: ${invIndex.code}`);
        }
    }

    getRangeForInvestmentIndexAndTerm(invIndex: InvestmentIndex, term: TermLength): AvailableDateRangeConfig {
        const baseRange = this.getRangeForInvestmentIndex(invIndex);
        const startYear = baseRange.startYear;
        const endYear = baseRange.endYear - (term.years - 1);
        return new YearRange(startYear, endYear);
    }
}